import React from "react";
import { Img_01, TermsImg } from "../../../Routes/ImagePath";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../../components/Breadcrumbs";

const FintrackAllTerms = () => {
  const cardData = [
    {
      imgSrc: TermsImg,
      cardTitle: "Card with image and list",
      cardListItems: [
        "Cras justo odio",
        "Dapibus ac facilisis in",
        "Vestibulum at eros",
      ],
    },
  ];
  return (
    <>
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle=" الشروط و الأحكام "
            title=" الرئيسية"
            subtitle=" شروط & أحكام"
          />
          <div className="small-container">
            <div className="inner-header text-center">
              <h1>
                شروط & أحكام
                <span className="text-primary"> Fintrack </span>
              </h1>
            </div>
            <div className="row">
              <div className="col-12 col-md-12 col-lg-12 d-flex">
                <div className="card flex-fill">
                  <img
                    src={TermsImg}
                    alt="Fintrack terms image"
                    className="card-img-top"
                  />
                  <div className="card-header p-4">
                    <h5 className="card-title mb-0 fs-4">
                      {" "}
                      شروط & أحكام
                      <span className="text-primary"> Fintrack </span>
                    </h5>
                  </div>

                  <ul className="list-group list-group-flush terms">
                    <li className="list-group-item p-4">
                      <Link to="/accessibility" className="link">
                        <i className="la la-get-pocket" />
                        <span>إمكانية الوصول </span>
                      </Link>
                    </li>
                    <li className="list-group-item p-4">
                      <Link to="/privacy-Policy">
                        <i className="la la-get-pocket" />

                        <span>سياسة الخصوصية</span>
                      </Link>
                    </li>
                    <li className="list-group-item p-4">
                      <Link to="/terms-conditions">
                        <i className="la la-get-pocket"></i>

                        <span> الأحكام والشروط </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* <div className="inner-content">
              <p className="lead">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip.
              </p>
              <p>
                {" "}
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
              </p>
              <h3>Etiam blandit lacus</h3>
              <p>
                {" "}
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
              </p>
              <p>
                {" "}
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
              </p>
              <h3>Maecenas sit amet</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
              </p>
            </div> */}
          </div>
        </div>
        {/* /Page Content */}
      </div>
    </>
  );
};
export default FintrackAllTerms;
